<template>
  <div class="container">
    <div class="main">
      <!-- <div class="wxCode">
        <img src="../assets/css/img/wxCode.jpg" alt="">
        <em>关注河南省循环经济与节能协会官方微信</em>
      </div> -->
      <div class="top">
        <div class="top-rolling">
          <swiper
            :options="swiperOption"
            ref="mySwiper"
            v-if="this.slideList.length > 0"
          >
            <swiper-slide v-for="(item, i) in slideList" :key="i">
              <img
                @click="toDeatils(item.id)"
                class="top-img"
                :src="item.image"
                alt=""
              />
              <span @click="toDeatils(item.id)" class="top-imgSpan">{{
                item.title
              }}</span>
            </swiper-slide>
            <div class="swiper-pagination" slot="pagination"></div>
            <!-- <div class="swiper-button-prev" slot="button-prev"></div>
            <div class="swiper-button-next" slot="button-next"></div> -->
          </swiper>
        </div>
        <!-- <div class="top-list1">
          <indexList
            :showSpan="'dynamics'"
            :toSpan="'dynamics'"
            :showTitle="'协会动态'"
            :isTop="isTop"
            :type="2"
          ></indexList>
        </div>
        <div class="top-list2">
          <indexList
            :showSpan="'message'"
            :toSpan="'message'"
            :showTitle="'重要通知'"
            :type="1"
            :showTime="showTime"
            :timeFront="timeFront"
          ></indexList>
        </div> -->
        <div class="top-tab">
          <el-tabs
            ref="navTabs"
            v-model="topActiveName"
            @tab-click="handleClick"
            type="card"
          >
            <el-tab-pane
              v-for="(item, index) in topTabsList"
              :key="index"
              :label="item.label"
              :name="item.name"
            >
              <span
                slot="label"
                style="color: #1954ad"
                @mouseover="topMouseover(item)"
                >{{ item.label }}</span
              >
              <div v-show="topActiveName == 'dynamics'" class="top-div">
                <indexList :toSpan="'dynamics'" :type="2"></indexList>
              </div>
              <div v-show="topActiveName == 'message'" class="top-div1">
                <indexList :toSpan="'message'" :type="1"></indexList>
              </div>
               <div v-show="topActiveName == 'news'" class="top-div1">
                <indexList :toSpan="'news'" :type="35"></indexList>
              </div>
            </el-tab-pane>
          </el-tabs>
        </div>
        <div class="top-button" @click="joinClub">加入协会</div>
      </div>
      <div class="banner">
        <img :src="bannerContent.image" alt="" />
      </div>
      <div class="middle">
        <div class="middle-tab">
          <el-tabs
            ref="navTabs2"
            v-model="middleActiveName"
            @tab-click="handleClick"
            type="card"
          >
            <el-tab-pane
              v-for="(item, index) in tabsList"
              :key="index"
              :label="item.label"
              :name="item.name"
            >
              <span
                slot="label"
                style="color: #1954ad"
                @mouseover="middleMouseover(item)"
                >{{ item.label }}</span
              >
              <div
                v-show="middleActiveName == 'edit'"
                class="middle-div middle-div1"
              >
                <indexList
                  :showTime="showTime"
                  :toSpan="'policyDocument'"
                  :type="3"
                ></indexList>
                <div class="middle-tabMore" @click="toList('policyDocument')">
                  >>
                </div>
              </div>
              <div
                v-show="middleActiveName == 'draft'"
                class="middle-div middle-div2"
              >
                <indexList
                  :showTime="showTime"
                  :toSpan="'law'"
                  :type="4"
                ></indexList>
                <div class="middle-tabMore" @click="toList('law')">>></div>
              </div>
              <div
                v-show="middleActiveName == 'release'"
                class="middle-div middle-div3"
              >
                <indexList
                  :showTime="showTime"
                  :toSpan="'policyExplain'"
                  :type="5"
                ></indexList>
                <div class="middle-tabMore" @click="toList('policyExplain')">
                  >>
                </div>
              </div>
            </el-tab-pane>
          </el-tabs>
        </div>
        <div class="middle-pic">
          <!-- <div class="pic-title">
            <div class="pic-titleSpan">河南循环经济</div>
             <div class="pic-arrow">
              <div
                class="arrow-left"
                :class="arrowActive == true ? 'active' : ''"
                @click="tabArrow"
              >
                <div class="arrow-leftIcon"></div>
              </div>
              <div
                class="arrow-right"
                :class="arrowActive == true ? '' : 'active'"
                @click="tabArrow"
              >
                <div class="arrow-rightIcon"></div>
              </div>
            </div> 
          </div> -->
          <div style="margin-top: -2px;">
            <indexList
            :toSpan="'henan'"
            :showSpan="'henan'"
            :showTitle="'河南省循环经济'"
            :type="9"
          ></indexList>
          </div>
          
          <!-- <div
            class="pic-content"
            v-if="arrowActive == true"
            @click="toDeatils(picContent1.id)"
          >
            <img :src="picContent1.image" alt="" />
            <div class="pic-title2">
              {{ picContent1.title }}
            </div>
            <p v-html="picContent1.content">
              {{ picContent1.content }}
            </p>
          </div>
          <div
            class="pic-content"
            v-if="arrowActive == false"
            @click="toDeatils(picContent2.id)"
          >
            <img :src="picContent2.image" alt="" />
            <div class="pic-title2">{{ picContent2.title }}</div>
            <p v-html="picContent2.content">
              {{ picContent2.content }}
            </p>
          </div> -->
        </div>
      </div>
      <div class="bottom">
        <div class="bottom-list">
          <indexList
            :toSpan="'report'"
            :showSpan="'report'"
            :showTitle="'中国循环经济发展报告'"
            :type="7"
          ></indexList>
        </div>
        <div class="bottom-list">
          <indexList
            :toSpan="'internet'"
            :showSpan="'internet'"
            :showTitle="'“互联网+”典型案例'"
            :type="8"
          ></indexList>
        </div>
        <div class="bottom-list">
          <indexList
            :toSpan="'loop'"
            :showSpan="'loop'"
            :showTitle="'专家观点'"
            :type="6"
          ></indexList>
        </div>
      </div>
      <div class="banner2">
        <ul>
          <li
            v-for="(item, i) in bottomBannerList"
            :key="i"
            @click="toDeatils(item.id)"
          >
            <div class="chairman-img">
              <img :src="item.image" alt="" />
            </div>
          </li>
        </ul>
      </div>
      <div class="chairman">
        <div class="chairman-title">
          <span>副会长单位</span>
          <span>排名不分先后</span>
        </div>
        <ul>
          <li
            v-for="(item, i) in chairmanList"
            :key="i"
            @click="toDeatils(item.id)"
          >
            <div class="chairman-img">
              <img :src="item.image" alt="" />
            </div>
            <div class="chairman-imgName">{{ item.title }}</div>
          </li>
        </ul>
      </div>
      <div class="link">
        <div class="link-title">
          <span>友情链接</span>
        </div>
        <div class="link-banner">
          <ul>
            <li v-for="(item, i) in linkBannerList" :key="i" @click="linkBanner(item.value)">
              <div class="chairman-img">
                <img :src="item.img" alt="" />
              </div>
            </li>
          </ul>
        </div>
        <div class="link-select">
          <div></div>
          <el-select
            v-model="association"
            placeholder="请选择"
            @change="linkChange"
          >
            <el-option
              v-for="(item, index) in associationList"
              :key="index"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
          <el-select v-model="union" placeholder="请选择" @change="linkChange">
            <el-option
              v-for="(item, index) in unionList"
              :key="index"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
          <el-select
            v-model="company"
            placeholder="请选择"
            @change="linkChange"
          >
            <el-option
              v-for="(item, index) in companyList"
              :key="index"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
          <el-select v-model="other" placeholder="请选择" @change="linkChange">
            <el-option
              v-for="(item, index) in otherList"
              :key="index"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { swiper, swiperSlide } from "vue-awesome-swiper";
import indexList from "../components/indexList";
import "swiper/dist/css/swiper.css";
export default {
  components: {
    swiper,
    swiperSlide,
    indexList,
  },
  name: "index",
  data() {
    return {
      //轮播图设置
      swiperOption: {
        loop: true,
        autoplay: {
          delay: 3000,
          stopOnLastSlide: false,
          disableOnInteraction: false,
        },
        // 显示分页
        pagination: {
          el: ".swiper-pagination",
          clickable: true, //允许分页点击跳转
        },
        // 设置点击箭头
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
      },
      topActiveName: "dynamics",
      middleActiveName: "edit",
      tabsList: [
        { label: "政策文件", name: "edit" },
        { label: "法律法规", name: "draft" },
        { label: "政策解读", name: "release" },
      ],
      topTabsList: [
        { label: "协会动态", name: "dynamics" },
        { label: "重要通知", name: "message" },
        { label: "行业新闻", name: "news" },
      ],
      showTime: "showTime",
      isTop: "isTop",
      timeFront: "timeFront",
      arrowActive: false,
      picId1: "",
      picId2: "",
      picContent1: "",
      picContent2: "",
      association: "行业协会",
      union: "联盟/专委会",
      company: "相关企业",
      other: "其他",
      //协会
      associationList: [
        { value: "行业协会", label: "行业协会" },
        { value: "https://www.chinacace.org/", label: "中国循环经济协会" },
        { value: "http://www.cecaweb.org.cn/", label: "中国节能协会" },
        { value: "http://www.crra.com.cn/", label: "中国物资再生协会" },
        { value: "http://www.crra.org.cn/", label: "中国再生资源回收利用协会" },
        { value: "http://www.camu.org.cn/", label: "中国废钢铁应用协会" },
        {
          value: "http://www.cecc-china.org/",
          label: "中华全国工商业联合会环境服务业商会",
        },
        {
          value: "http://www.ctra.org.cn/",
          label: "中国轮胎翻修与循环利用协会",
        },
        // { value: "http://www.aeecenter.org/", label: "能源工程师协会" },
        { value: "http://www.wuhaneca.org", label: "武汉市节能协会" },
        { value: "http://www.sxjzjn.org/", label: "陕西省建筑节能协会" },
      ],
      //联盟/专委会
      unionList: [
        { value: "联盟/专委会", label: "联盟/专委会" },
        // { value: "http://www.ase.org/", label: "美国节能联盟" },
        { value: "http://www.ciar.org.cn/", label: "再生资源产业技术创新联盟" },
        // {
        //   value: "http://awtcu.chinacace.org/",
        //   label: "废旧纺织品综合利用专业委员会",
        // },
        // {
        //   value: "http://www.chinaaceer.org",
        //   label: "农业循环经济与生态修复专业委员会",
        // },
        // {
        //   value: "http://www.scircu.org/",
        //   label: "工业资源综合利用专业委员会",
        // },
        // {
        //   value: "http://www.umida.icoc.me",
        //   label: "城市资源循环利用专业委员会",
        // },
        // {
        //   value: "http://www.irpu.icoc.me",
        //   label: "互联网+资源循环利用专业委员会",
        // },
      ],
      //相关企业
      companyList: [
        { value: "相关企业", label: "相关企业" },
        // { value: "http://www.iso50001.com.cn/", label: "能源管理体系网" },
        { value: "http://www.h2o-china.com/", label: "中国水网" },
        { value: "http://www.solidwaste.com.cn/", label: "中国固废网" },
        { value: "http://www.chndaqi.com/", label: "中国大气网" },
        { value: "http://www.ezaisheng.com", label: "易再生网" },
      ],
      //其他
      otherList: [
        { value: "其他", label: "其他" },
        { value: "http://www.cnal.com/", label: "中铝网" },
        // {
        //   value: "http://www.flyingash.com/index.asp",
        //   label: "粉煤灰综合利用网",
        // },
        // { value: "http://www.cusdn.org.cn/", label: "中国城市低碳经济网" },
        { value: "http://www.cnfjwz.com/", label: "中国废旧物资网" },
        // {
        //   value: "http://china.worldscrap.com/modules/cn/",
        //   label: "世界再生网",
        // },
        // { value: "http://www.crrainfo.org/", label: "再生资源信息网" },
        // { value: "http://www.crra010.com/", label: "中国资源再生交易网" },
        // { value: "http://www.sinorrc.com/", label: "中国零部件再生交易网" },
      ],
      slideList: [],
      chairmanList: [],
      bannerId: "",
      bannerContent: "",
      bottomBannerList: [],
      //友情链接banner
      linkBannerList: [
        {
          value: "https://www.ndrc.gov.cn/",
          img: require("../assets/css/img/link-pic01.jpg"),
        },
        {
          value: "http://www.chinanecc.cn/website/index.shtml",
          img: require("../assets/css/img/link-pic02.jpg"),
        },
        {
          value: "https://fgw.henan.gov.cn/",
          img: require("../assets/css/img/link-pic03.jpg"),
        },
        {
          value: "http://www.sac.gov.cn/",
          img: require("../assets/css/img/link-pic04.jpg"),
        },
        {
          value: "http://www.henan.gov.cn/",
          img: require("../assets/css/img/link-pic05.jpg"),
        },
        {
          value: "https://gxt.henan.gov.cn/",
          img: require("../assets/css/img/link-pic06.jpg"),
        },
        {
          value: "http://www.hndb41.com/",
          img: require("../assets/css/img/link-pic07.jpg"),
        },
      ],
    };
  },
  methods: {
    handleClick(tab, event) {
      console.log("tab", tab, event);
    },
    tabArrow() {
      this.arrowActive = !this.arrowActive;
    },
    //跳转到详情
    toDeatils(id) {
      if (id) {
        this.$router.push({
          path: this.$route.name + "/newDetails",
          query: { id: id },
        });
      }
    },
    // 副会长单位列表
    async getList() {
      let params = {
        type: 22,
      };
      try {
        const res = await this.API.plat.pageList(params);
        if (res.success == true) {
          this.chairmanList = res.entity.content.slice(0, 6);
        }
      } catch (error) {
        // console.log(error);
      }
    },
    // 轮播图列表
    async getList2() {
      let params = {
        type: 10,
      };
      try {
        const res = await this.API.plat.pageList(params);
        if (res.success == true) {
          this.slideList = res.entity.content.slice(0, 3);
        }
      } catch (error) {
        // console.log(error);
      }
    },
    // 河南循环经济
    async getList3() {
      let params = {
        type: 9,
      };
      try {
        const res = await this.API.plat.pageList(params);
        if (res.success == true) {
          if (res.entity.content[0] != undefined) {
            this.picId1 = res.entity.content[0].id;
            this.picContent1 = res.entity.content[0];
            // this.getNewsDetails1();
          }
          if (res.entity.content[1] != undefined) {
            this.picId2 = res.entity.content[1].id;
            this.picContent2 = res.entity.content[1];
            // this.getNewsDetails2();
          }
        }
      } catch (error) {
        console.log(error);
      }
    },
    // 顶部banner
    async getList4() {
      let params = {
        type: 37,
      };
      try {
        const res = await this.API.plat.pageList(params);
        if (res.success == true) {
          if (res.entity.content[0] != undefined) {
            this.bannerId = res.entity.content[0].id;
            this.bannerContent = res.entity.content[0];
          }
        }
      } catch (error) {
        console.log(error);
      }
    },
    // 底部banner
    async getList5() {
      let params = {
        type: 38,
      };
      try {
        const res = await this.API.plat.pageList(params);
        if (res.success == true) {
          this.bottomBannerList = res.entity.content.slice(0, 4);
        }
      } catch (error) {
        console.log(error);
      }
    },
    // 委员会详情1
    async getNewsDetails1() {
      let params = {
        id: this.picId1,
      };
      try {
        const res = await this.API.plat.newsDetails(params);
        if (res.success == true) {
          this.picContent1 = res.entity;
        }
      } catch (error) {
        // console.log(error);
      }
    },
    // 委员会详情2
    async getNewsDetails2() {
      let params = {
        id: this.picId2,
      };
      try {
        const res = await this.API.plat.newsDetails(params);
        if (res.success == true) {
          this.picContent2 = res.entity;
        }
      } catch (error) {
        // console.log(error);
      }
    },
    //跳转到列表
    toList(showSpan) {
      this.$router.push({
        path: showSpan,
      });
    },
    //加入协会
    joinClub() {
      this.$router.push({
        name: "/join",
        url: "/join",
      });
    },
    //友情链接
    linkChange(val) {
      if (val.indexOf("http") != -1) {
        window.open(val); // 在新窗口打开外链接
      }
    },
    //友情链接banner
    linkBanner(val){
      if (val.indexOf("http") != -1) {
        window.open(val); // 在新窗口打开外链接
      }
    },
    topMouseover(item) {
      this.topActiveName = item.name;
    },
    middleMouseover(item) {
      this.middleActiveName = item.name;
    },
  },
  computed: {
    swiper() {
      return this.$refs.mySwiper.swiper;
    },
  },
  created() {
    this.getList();
    this.getList2();
    this.getList3();
    this.getList4();
    this.getList5();
  },
  mounted() {
    // console.log('屏幕分辨率的高',window.screen.height)
    // console.log('网页可见区域高', document.body.clientHeight)
    // current swiper instance
    // 然后你就可以使用当前上下文内的swiper对象去做你想做的事了
    // console.log("this is current swiper instance object", this.swiper);
    // this.swiper.slideTo(3, 1000, false);
    // this.$nextTick(() => {
    //   // 页面渲染完成后的回调
    //   setTimeout(() => {
    //     console.log("--------------", this.$refs.ccc[0].offsetHeight);
    //   }, 100);
    // });
    // this.$nextTick(() => {
    //   this.$refs.navTabs.$refs.nav.$nextTick(() => {
    //     // 此时tab的nav才渲染dom 否则拿不到el-tabs__item
    //     var target = document.getElementsByClassName("el-tabs__item");
    //     let that = this;
    //     for (let i = 0; i < target.length; i++) {
    //       target[i].addEventListener("mouseover", () => {
    //         that.$refs.navTabs.handleTabClick(1, String(i));
    //       });
    //     }
    //   });
    // });
  },
};
</script>

<style scoped lang="scss">
.container {
  display: flex;
  justify-content: center;
  min-height: 800px;
  .main {
    // width: 70%; //固定宽度改为百分比
    width: 1200px;
    // border: 1px solid #ccc;
    z-index: 99;
    // display: flex;
    // .wxCode{
    //   position: fixed;
    //   right: 20px;
    //   top: 184px;
    //   width: 105px;
    //   padding: 5px;
    //   text-align: center;
    //   font-size: 12px;
    //   border: 1px solid #ccc;
    //   z-index: 101;
    //   background: #fff;
    //   img{
    //     width: 90px;
    //     height: 90px;
    //   }
    //   em{
    //     font-style: normal;
    //     line-height: 15px;
    //   }
    //}
    .top {
      width: 100%;
      display: flex;
      height: 420px;
      margin-bottom: 20px;
      position: relative;
      .top-rolling {
        width: 60%;
        margin: 0 20px 0 0;
        // border: 1px solid #ccc;
        border-radius: 1px;
        box-shadow: 0px 1px 3px 0px rgba(0, 0, 0, 0.1);
        height: 100%;
        .swiper-container {
          position: relative;
          width: 100%;
          height: 416px;
          .swiper-slide {
            width: 100%;
            // height: 385px;
            line-height: 200px;
            font-size: 16px;
            text-align: left;
            position: relative;
            background: #fff;
            cursor: pointer;
            .top-img {
              width: 100%;
              // height: 340px;
              height: 100%;
              object-fit: cover;
            }
            .top-imgSpan {
              position: relative;
              bottom: 176px;
              left: 0px;
              height: 80px;
              line-height: 78px;
              padding: 0 200px 0 20px;
              color: #fff;
              width: 100%;
              display: block;
              font-size: 20px;
              font-weight: 550;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
              background: rgba(0, 0, 0, 0.7);
            }
          }
        }
      }
      .top-list1 {
        width: 38%;
        height: 100%;
        margin: 0 20px 0 0;
        // border: 1px solid #ccc;
        border-radius: 1px;
        box-shadow: 0px 1px 3px 0px rgba(0, 0, 0, 0.1);
        background: #fff;
        overflow: hidden;
      }
      .top-list2 {
        width: 24%;
        height: 100%;
        // border: 1px solid #ccc;
        border-radius: 1px;
        box-shadow: 0px 1px 3px 0px rgba(0, 0, 0, 0.1);
        background: #fff;
        overflow: hidden;
      }
      .top-tab {
        width: 40%; //固定宽度改为百分比
        // margin: 0 20px 0 0;
        border-radius: 1px;
        box-shadow: 0px 1px 3px 0px rgba(0, 0, 0, 0.1);
        background: #fff;
        overflow: hidden;
        height: 360px;
      }
      .top-div {
        left: 0;
        position: relative;
        overflow: hidden;
        padding: 0px;
        margin: 0px;
        transform: translate(0, 0);
        transition: all linear 2s;
      }
      .top-button {
        position: absolute;
        right: 0;
        bottom: 0;
        width: 38.38%;
        height: 60px;
        line-height: 60px;
        color: #fff;
        background: #0e90f2;
        text-align: center;
        border-radius: 2px;
        cursor: pointer;
      }
      .top-button:hover {
        background: #0c70bc;
      }
    }
    .banner {
      width: 100%;
      display: flex;
      height: 96px;
      margin-bottom: 20px;
      img {
        width: 100%;
        object-fit: cover;
      }
    }
    .banner2 {
      width: 100%;
      display: flex;
      height: 80px;
      margin-bottom: 20px;
      ul {
        display: flex;
        justify-content: space-between;
        width: 100%;
        li {
          // flex: 1;
          width: 290px;
          text-align: center;
          height: 100%;
          cursor: pointer;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          .chairman-img {
            width: 290px;
            height: 80px;
            display: inline-block;
            img {
              width: 100%;
              height: 100%;
              object-fit: cover;
            }
          }
        }
      }
    }
    .middle {
      width: 100%;
      display: flex;
      height: 418px;
      margin-bottom: 20px;
      .middle-tab {
        // width: 604px;
        width: 60%; //固定宽度改为百分比
        margin: 0 20px 0 0;
        // border: 1px solid #ccc;
        border-radius: 1px;
        box-shadow: 0px 1px 3px 0px rgba(0, 0, 0, 0.1);
        background: #fff;
        overflow: hidden;
        .middle-div {
          position: relative;
          min-height: 418px;
          .middle-tabMore {
            position: absolute;
            top: 336px;
            right: 6px;
            z-index: 9999;
            cursor: pointer;
            background-image: url("../assets/css/img/arrow-R.svg");
            background-repeat: no-repeat;
            color: transparent;
            background-position: center;
          }
        }
      }
      .middle-pic {
        width: 38.5%;
        max-width: 38.5%; //固定宽度改为百分比
        // border: 1px solid #ccc;
        border-radius: 1px;
        box-shadow: 0px 1px 3px 0px rgba(0, 0, 0, 0.1);
        background: #fff;
        cursor: pointer;
        overflow: hidden;
        .pic-title {
          height: 40px;
          line-height: 56px;
          font-weight: 550;
          padding: 0 38px;
          display: flex;
          justify-content: space-between;
          .pic-titleSpan {
            font-size: 18px;
            color: #1954ad;
          }
          .pic-arrow {
            display: flex;
            align-items: flex-end;
            .active {
              background: #468ffc !important;
            }
            .arrow-left {
              width: 16px;
              height: 16px;
              background: #b8babc;
              margin-right: 5px;
              .arrow-leftIcon {
                width: 0;
                height: 0;
                border: 6px solid transparent; //所有border都是透明的，
                border-right-color: #fff;
                margin: 2px 0 0 -2px;
              }
            }
            .arrow-right {
              width: 16px;
              height: 16px;
              background: #b8babc;
              .arrow-rightIcon {
                width: 0;
                height: 0;
                border: 6px solid transparent; //所有border都是透明的，
                border-left-color: #fff;
                margin: 2px 0 0 6px;
              }
            }
          }
        }
        .pic-content {
          width: 90%;
          margin: 0 auto;
          height: 360px;
          text-align: center;
          overflow: hidden;
          img {
            // width: 90%;
            // height: 246px;
            padding: 20px 0;
            width: 90%;
            height: 80%;
            object-fit: cover;
          }
          .pic-title2 {
            width: 60%;
            padding-left: 20px;
            padding-top: 1px;
            text-align: left;
            font-size: 16px;
            color: #000;
            margin-bottom: 7px;
            font-weight: 550;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
          }
          p {
            width: 96%;
            padding-left: 20px;
            text-align: left;
            font-size: 14px;
            color: rgb(51, 51, 51);
            line-height: 26px;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 2;
            max-height: 52px;
            overflow: hidden;
          }
        }
      }
    }
    .bottom {
      width: 100%;
      display: flex;
      // height: 420px;
      height: 240px;
      margin-bottom: 20px;
      .bottom-list {
        width: 33%;
        margin: 0 20px 0 0;
        // border: 1px solid #ccc;
        border-radius: 1px;
        box-shadow: 0px 1px 3px 0px rgba(0, 0, 0, 0.1);
        background: #fff;
        overflow: hidden;
      }
      .bottom-list:last-child {
        margin: 0;
      }
    }
    .chairman {
      width: 100%;
      height: 272px;
      background: #fff;
      margin-bottom: 20px;
      // border: 1px solid #ccc;
      border-radius: 1px;
      box-shadow: 0px 1px 3px 0px rgba(0, 0, 0, 0.1);
      .chairman-title {
        height: 60px;
        line-height: 60px;
        padding: 0 30px;
        border-bottom: 2px solid #eaeaea;
        span:nth-child(1) {
          font-weight: 550;
          font-size: 18px;
          color: #1954ad;
          margin-right: 30px;
        }
      }
      ul {
        display: flex;
        height: 210px;
        li {
          flex: 1;
          height: 210px;
          text-align: center;
          margin: 30px 0;
          cursor: pointer;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          .chairman-img {
            width: 149px;
            height: 100px;
            display: inline-block;
            box-shadow: 0px 5px 10px 0px rgba(0, 0, 0, 0.1);
            img {
              width: 100%;
              height: 100%;
              // object-fit: cover;
              object-fit: contain;
            }
          }
          // img {
          //   width: 149px;
          //   height: 100px;
          //   object-fit: cover;
          // }
          .chairman-imgName {
            margin-top: 26px;
            font-size: 18px;
            color: #333;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
          }
        }
      }
    }
    .link {
      width: 100%;
      height: 210px;
      background: #fff;
      margin-bottom: 20px;
      // border: 1px solid #ccc;
      border-radius: 1px;
      box-shadow: 0px 1px 3px 0px rgba(0, 0, 0, 0.1);
      .link-title {
        height: 60px;
        line-height: 60px;
        padding: 0 30px;
        border-bottom: 2px solid #eaeaea;
        span {
          font-weight: 550;
          font-size: 18px;
          color: #1954ad;
          margin-right: 30px;
        }
      }
      .link-banner {
        margin: 20px 20px 0;
        ul {
          display: flex;
          justify-content: space-between;
          width: 100%;
          li {
            flex: 1;
            // width: 290px;
            text-align: center;
            height: 100%;
            cursor: pointer;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            .chairman-img {
              width: 127px;
              height: 38px;
              display: inline-block;
              img {
                width: 100%;
                height: 100%;
                object-fit: cover;
              }
            }
          }
        }
      }
      .link-select {
        display: flex;
        height: 80px;
        justify-content: center;
        align-items: center;
        margin: 0 20px;
        .el-select {
          padding: 0 15px;
          flex: 1;
        }
      }
    }
  }
}
::v-deep .top-tab .list-container .ul-notTop .list1 {
  height: 43px !important;
  min-height: 43px !important;
}
.swiper-pagination-fraction,
.swiper-pagination-custom,
.swiper-container-horizontal > .swiper-pagination-bullets {
  bottom: 32px;
  left: 40%;
}
// ::v-deep .swiper-wrapper {
//   height: 94% !important;
// }
::v-deep .swiper-pagination-bullet {
  width: 12px !important;
  height: 12px !important;
  background: #f2f0f0;
  opacity: 1;
}
::v-deep .swiper-pagination-bullet-active {
  background: #468ffc;
}
::v-deep .el-tabs--card > .el-tabs__header {
  border: none !important;
  margin-bottom: 0;
}
::v-deep .el-tabs__nav {
  width: 100%;
  display: flex;
  border: none !important;
  height: 60px;
  line-height: 60px;
  background: #edf4ff;
}
::v-deep .el-tabs__item {
  // width: 33%;
  flex: 1;
  border: none !important;
  text-align: center;
  font-size: 18px;
  color: #1954ad;
  font-weight: 550;
  height: 60px;
  line-height: 60px;
}
::v-deep .el-tabs--card > .el-tabs__header .el-tabs__item.is-active {
  background: #0e90f2;
  color: #fff;
  span {
    color: #fff !important;
  }
}
/* 动画sta */
// @-webkit-keyframes top-div {
//    0% {
//     -webkit-transform: translateX(1000px);
//             transform: translateX(1000px);
//     opacity: 0;
//   }
//   100% {
//     -webkit-transform: translateX(0);
//             transform: translateX(0);
//     opacity: 1;
//   }
// }
// @keyframes top-div1 {
//     0% {
//     -webkit-transform: translateX(-1000px);
//             transform: translateX(-1000px);
//     opacity: 0;
//   }
//   100% {
//     -webkit-transform: translateX(0);
//             transform: translateX(0);
//     opacity: 1;
//   }
// }
@keyframes top-div {
  from {
    transform: translateX(1000px);
  }

  to {
    transform: translateX(0);
  }
}

@keyframes top-div1 {
  from {
    transform: translateX(1000px);
  }

  to {
    transform: translateX(0);
  }
}
.top-div {
  -webkit-animation: top-div 0.8s ease-out both;
  animation: top-div 0.8s ease-out both;
}

.top-div1 {
  -webkit-animation: top-div1 0.8s ease-out both;
  animation: top-div1 0.8s ease-out both;
}

@keyframes middle-div1 {
  from {
    transform: translateX(1000px);
  }

  to {
    transform: translateX(0);
  }
}

@keyframes middle-div2 {
  from {
    transform: translateX(1000px);
  }

  to {
    transform: translateX(0);
  }
}

@keyframes middle-div3 {
  from {
    transform: translateX(1000px);
  }

  to {
    transform: translateX(0);
  }
}
.middle-div1 {
  -webkit-animation: middle-div1 0.8s ease-out both;
  animation: middle-div1 0.8s ease-out both;
}
.middle-div2 {
  -webkit-animation: middle-div2 0.8s ease-out both;
  animation: middle-div2 0.8s ease-out both;
}
.middle-div3 {
  -webkit-animation: middle-div3 0.8s ease-out both;
  animation: middle-div3 0.8s ease-out both;
}
</style>